import { useMemo } from "react";
import { useAppSelector, selectors } from "store";
import { useChartTimeline, percentToDisplayTime, } from "ui/components/elements/chart/chart-timeline";
/**
 * Linear interpolation of `values` (parallel to `times`) at `apiTime`.
 *
 * Mirrors interpolateVacuumLevel: clamps to the first/last sample when
 * `apiTime` falls outside the range. Returns 0 when there is no data.
 */
export var interpolateByTime = function (times, values, apiTime) {
    var _a, _b, _c, _d;
    if (!times.length || !values.length)
        return 0;
    var idx = times.findIndex(function (t) { return t >= apiTime; });
    if (idx === -1)
        return (_a = values[values.length - 1]) !== null && _a !== void 0 ? _a : 0;
    if (idx === 0)
        return (_b = values[0]) !== null && _b !== void 0 ? _b : 0;
    var t0 = times[idx - 1];
    var t1 = times[idx];
    var v0 = (_c = values[idx - 1]) !== null && _c !== void 0 ? _c : 0;
    var v1 = (_d = values[idx]) !== null && _d !== void 0 ? _d : 0;
    var alpha = t1 === t0 ? 0 : (apiTime - t0) / (t1 - t0);
    return v0 + alpha * (v1 - v0);
};
/**
 * Returns the system total vertical & horizontal lifting force at the current
 * play position, or undefined when the time-series data is not available.
 *
 * Uses the same percent→display-time mapping as the graph PlayLine (see
 * use-current-vacuum-level) so the sampled value lines up exactly with the
 * rendered play head.
 */
export var useCurrentLiftingForce = function () {
    var playLocationPercent = useAppSelector(selectors.selectPlayLocationPercent);
    var performanceData = useAppSelector(selectors.selectActivePerformanceData);
    var timeline = useChartTimeline();
    return useMemo(function () {
        if (!performanceData || !timeline)
            return undefined;
        var times = performanceData.vacuumLevelTimeData, vertical = performanceData.liftingForceVerticalVsTime, horizontal = performanceData.liftingForceHorizontalVsTime;
        if (!times.length || !(vertical === null || vertical === void 0 ? void 0 : vertical.length) || !(horizontal === null || horizontal === void 0 ? void 0 : horizontal.length))
            return undefined;
        var apiTime = percentToDisplayTime(playLocationPercent, timeline);
        return {
            vertical: interpolateByTime(times, vertical, apiTime),
            horizontal: interpolateByTime(times, horizontal, apiTime),
        };
    }, [performanceData, timeline, playLocationPercent]);
};
